import request from '@/http/http'
const PREFIX = 'api/deer/weixin';
// 获取微信群发消息记录
export function getWeixinMassTemps(query) {
    return request({
        url: PREFIX+'/mass-temps',
        params:query
    })
}
// 群发预约楼盘模板消息
export function sendMassAppointmentEstateTemp(data) {
    return request({
        url: PREFIX+'/send-mass-appointment-estate-temp',
        method: 'post',
        data
    })
}